

const Caption = ({ showContent, caption, captionPosition }) => {
    return (showContent.caption && caption) && <div className={`caption ${captionPosition?.position}`}>
        <p>{caption}</p>
    </div>
}
export default Caption;